import PropTypes from 'prop-types';
import React from 'react';

import Paper from '@glass/web/components/base/Paper';
import resumeSize from '@glass/web/modules/resumes/templates/resumeSize';

import AspectRatio from '@glass/shared/components/AspectRatio/AspectRatio';
import ResponsiveResumeImage from '@glass/shared/components/ResumeBuilder/ResponsiveResumeImage';

function ResumeImage({ className, children, ...props }) {
  return (
    <Paper square className={className}>
      <AspectRatio height={resumeSize.height} width={resumeSize.width}>
        <ResponsiveResumeImage {...props} />
        {children}
      </AspectRatio>
    </Paper>
  );
}

ResumeImage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ResumeImage;
